import '../chart_view.js.coffee'

Namespace 'Monitoring.Views.Charts'

class Monitoring.Views.Charts.WordsRankingChartView extends Monitoring.Views.Charts.ChartView
  generic_template: JST['backbone/templates/monitoring/charts/generic_chart_with_csv']
  word_template: JST['backbone/templates/monitoring/charts/word_ranking']
  message_template: JST['backbone/templates/monitoring/charts/message_ranking']
  phrase_template: JST['backbone/templates/monitoring/charts/phrase_ranking']
  className: 'item word-ranking h2 w2'
  title: ''
  title_en: ''

  events:
    'click .emergent-topic': '_previewSearch'
    'click .long-topic .topic': '_previewSearchWithIds'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'
    'click .chart-export-menu-button': 'onClickMenu'
    'click .chart-export-menu-option': 'onClickMenuOption'
    'click .export-csv': 'export2csv'
    'click .expand-topic': 'expandTopic'
    'click .collapse-topic': 'collapseTopic'
    'mouseover .info-tooltip': 'showTooltip'
    'mouseout .info-tooltip': 'hideTooltip'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @calculator = @options.calculator
    @calculator.on("calculate_#{@jobName()}", @calculate)
    @_settings = @options.settings
    @container = @options.container

  jobName: ->
    'words'

  ngramsLimit: ->
    20

  _dataIsEmpty: ->
    return false

  render: ->
    @$el.html(@generic_template({
      title: @title,
      chart_class: 'rankingWidget processing'
    }))

    @$el.find('.chart-export-menu').popover()

    @trigger('masonry')
    return this

  afterAppend: ->
    job = @calculator.calculate(@jobName(), @ngramsLimit())
    job.bind('failed', @displayError) if job

  calculate: (response) =>
    unless @alreadyCalculated
      @response = response
      @alreadyCalculated = true
      content_count_title = I18n.t('monitoring.dashboard.charts.ranking.contents')
      score_title = I18n.t('monitoring.dashboard.charts.ranking.score')
      topic_title = I18n.t('monitoring.dashboard.charts.ranking.topics')
      phrase_title = I18n.t('monitoring.dashboard.charts.ranking.phrase')
      message_title = I18n.t('monitoring.dashboard.charts.ranking.message')
      ranking_tooltip = I18n.t('monitoring.dashboard.charts.ranking.topics_tooltip')
      phrases_tooltip = I18n.t('monitoring.dashboard.charts.ranking.phrases_tooltip')
      messages_tooltip = I18n.t('monitoring.dashboard.charts.ranking.messages_tooltip')
      empty_phrases = I18n.t('monitoring.dashboard.charts.ranking.empty_phrases')
      empty_messages = I18n.t('monitoring.dashboard.charts.ranking.empty_messages')
      @$el.find('.chart').append('<div id="rankingDiscovered" class="slim-scrollbar">')
      @$el.find('.chart #rankingDiscovered').append("<i class='fa fa-sort-amount-desc'></i><span class='title'> Topic Ranking </span><i class='fa fa-info-circle info-tooltip'></i>")
      @$el.find('.chart #rankingDiscovered').append("<span class='ranking-tooltip'>"+ranking_tooltip+"</span>")
      @$el.find('.chart #rankingDiscovered').append("<table class='rankingContainer'>")
      @$el.find('.chart #rankingDiscovered .rankingContainer').append("<tr><th>" +topic_title+ "</th><th>"+content_count_title+"</th><th>"+score_title+"</th></tr>")
      _.each response.topic_ranking, (value, index) =>
        value.escaped_topic_ids = _.map(value.topic_ids, (topic_id) => topic_id.replace("'", '&#39'))
        value.score = parseFloat(value.score.toFixed(1))
        @$el.find('.chart #rankingDiscovered .rankingContainer').append(@word_template(value))
      @$el.find('.chart #rankingDiscovered').append("</table>")
      @$el.find('.chart').append("</div>")
      @$el.find('.chart').append("<div class='divider'></div>")
      @$el.find('.chart').append("<div id='longTopics'>")
      @$el.find('.chart #longTopics').append("<div id='rankingPhrases'>")
      @$el.find('.chart #rankingPhrases').append("<i class='fa fa-quote-left'></i><span class='title'> Relevant Phrases </span><i class='fa fa-info-circle info-tooltip'></i>")
      @$el.find('.chart #rankingPhrases').append("<span class='ranking-tooltip'>"+phrases_tooltip+"</span>")
      @$el.find('.chart #rankingPhrases').append("<div class='rankingContainer'>")
      if response.phrases.length > 0
        _.each response.phrases, (value, index) =>
          value.escaped_content_ids = _.map(value.content_ids, (content_id) => content_id.replace("'", '&#39'))
          @$el.find('.chart #rankingPhrases .rankingContainer').append(@phrase_template(value))
      else
        @$el.find('.chart #rankingPhrases .rankingContainer').addClass('emptyRanking')
        @$el.find('.chart #rankingPhrases .rankingContainer').append("<span> "+empty_phrases+" </span>")
      @$el.find('.chart #rankingPhrases').append("</div>")
      @$el.find('.chart #rankingPhrases').append("</div>")
      @$el.find('.chart #longTopics').append("<div id='rankingMessages'>")
      @$el.find('.chart #rankingMessages').append("<i class='fa fa-user'></i><span class='title'> Relevant Messages </span><i class='fa fa-info-circle info-tooltip'></i>")
      @$el.find('.chart #rankingMessages').append("<span class='ranking-tooltip'>"+messages_tooltip+"</span>")
      @$el.find('.chart #rankingMessages').append("<div class='rankingContainer'>")
      if response.relevant_messages.length > 0
        _.each response.relevant_messages, (value, index) =>
          value.escaped_content_ids = _.map(value.content_ids, (content_id) => content_id.replace("'", '&#39'))
          @$el.find('.chart #rankingMessages .rankingContainer').append(@message_template(value))
      else
        @$el.find('.chart #rankingMessages .rankingContainer').addClass('emptyRanking')
        @$el.find('.chart #rankingMessages .rankingContainer').append("<span> "+empty_messages+" </span>")
      @$el.find('.chart #rankingMessages').append("</div>")
      @$el.find('.chart').append("</div>")
      @afterCalculate(response)

  afterCalculate: (response) ->
    @$el.find('.rankingWidget').removeClass('processing')
    @trigger('masonry')
    _.each @$el.find('.long-topic .topic'), (elem) =>
      if !this.isOverflown(elem)
        $(elem).siblings('.expand-topic').hide();

  showTooltip:(event) ->
    $(event.currentTarget).siblings('.ranking-tooltip').css('visibility','visible');


  hideTooltip:(event) ->
    $(event.currentTarget).siblings('.ranking-tooltip').css('visibility','hidden');

  _previewSearch: (event) ->
    topic = $(event.currentTarget).find('.ngram')
    topics_ids = _.map(topic.data('ngram'), (topic_id) -> topic_id.replace('&#39', "'"))
    query = @getDiscoveredTopicsQuery(topics_ids)
    @doPreviewSearch(query)

  _previewSearchWithIds: (event) ->
    content_ids = $(event.currentTarget).data('contents')
    content_ids = _.map(content_ids, (content_id) -> content_id.replace('&#39', "'"))
    query = @getContentsQuery(content_ids)
    @doPreviewSearch(query)

  doPreviewSearch: (query) ->
    return if @_settings.avoid_preview
    @createPreviewDashboard(query)

  getDiscoveredTopicsQuery: (topic_ids) ->
    query = @searchQuery.deepCopy()
    query.set('discovered_topics_ids', topic_ids)
    return query

  getContentsQuery: (content_ids) ->
    query = @searchQuery.deepCopy()
    query.addContentId(content_ids)
    return query

  export2csv: ->
    content_count_title = I18n.t('monitoring.dashboard.charts.ranking.contents')
    score_title = I18n.t('monitoring.dashboard.charts.ranking.score')
    topic_title = I18n.t('monitoring.dashboard.charts.ranking.topics')
    alternative_forms = I18n.t('monitoring.dashboard.charts.ranking.alternative_forms')
    csv = [topic_title + ", " + content_count_title + ", " + score_title + ", " + alternative_forms + ", ID"]
    _.each @response.topic_ranking, (topic_data, index) =>
      csv.push ( topic_data.topic + ", " + topic_data.appearances_count + ", " + topic_data.score + ', "' + topic_data.alternative_forms.join(', ') + '", ' + topic_data.id.join(' ') )
      csv[index] = csv[index].replace(/\s+/g,' ')

    csv2export = ""
    _.map(csv, (row)->
      csv2export = csv2export + row + "\n"
    )
    element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv2export));
    element.setAttribute('download', 'topic_ranking.csv');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

  expandTopic:(event) ->
    topic = $(event.currentTarget).siblings('.topic');
    topic.css('overflow','overlay');
    topic.css('white-space','normal');
    other_expanded_topic = $('.collapse-topic').siblings('.topic')
    $(event.currentTarget).removeClass('expand-topic')
    $(event.currentTarget).removeClass('fa-plus-square')
    $(event.currentTarget).addClass('collapse-topic')
    $(event.currentTarget).addClass('fa-minus-square')
    if other_expanded_topic.length > 0
      @hideTopic(other_expanded_topic)

  collapseTopic:(event) ->
    topic = $(event.currentTarget).siblings('.topic');
    @hideTopic(topic)

  hideTopic:(topic) ->
    topic.css('overflow','hidden');
    topic.css('white-space','nowrap');
    button = topic.siblings('.collapse-topic')
    button.removeClass('collapse-topic')
    button.removeClass('fa-minus-square')
    button.addClass('expand-topic')
    button.addClass('fa-plus-square')

  isOverflown:(element) ->
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;

  onClickMenu: ->
    menuOptions = @$el.find('.chart-export-menu-options')
    if menuOptions.css('display') == 'none'
      menuOptions.css('display', 'block')
    else
      menuOptions.css('display', 'none')

  onClickMenuOption: ->
    menuOptions = @$el.find('.chart-export-menu-options')
    menuOptions.css('display', 'none')

  displayError: (response) =>
    if response.results == 'Keepcon::Exceptions::DefaultLanguageUndefinedException'
      @_displayError(message: I18n.t('monitoring.dashboard.charts.ranking.undefined_language'), allowRetry: false)
    else
      super(response)

  cloneDashboard: (searchQuery)->
    # analysis mode is peak peek session. Rankings drilldown works for explorer session.
    query = searchQuery.deepCopy()
    if query.get('analysisMode')
      query.set('analysisMode', false)
      query.set('exploreMode', true)

    @eventAggregator.trigger('clickOnCloneDashboard', query)
